import { types, SnapshotIn } from "mobx-state-tree";

const FilterItem = types.model({
  id: types.identifier,
  name: types.string,
});

export default FilterItem;
export interface IFilterItemSnapshotIn extends SnapshotIn<typeof FilterItem> {}
